import { createFileRoute } from '@tanstack/react-router'

import { DuplicateReviewPage } from '@/modules/insights/pages'

export const Route = createFileRoute(
  '/_authenticated/projects/$slug/insights_/duplicates/$groupId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { slug, groupId } = Route.useParams()

  return <DuplicateReviewPage slug={slug} groupId={groupId} />
}
